import { Button, Checkbox, FormControlLabel,  Slide, Snackbar, TextField } from '@material-ui/core'
import React, { useState } from 'react'
import Http from '../../../Http';

export default function PagoEntrega({ sucursal = {}, onChange = () => { } }) {
  const [SB, setSB] = useState({ open: false, msg: null });

  const _onChange = (key, value) => {
    sucursal[key] = value;
    onChange(sucursal);
  }

  const savePorcentajes = async () => {
    console.log(sucursal)
    try {
      let Res = await Http.post(`sucursal/save`, { ...sucursal });
      console.log(Res)
      if (!Res.error) {
        setSB({ msg: 'Guardados', open: true });
      }
    } catch (error) {
      console.log(error)
    }
  }

  // console.log(sucursal);
  return (
    <div>
      <h4>Pagos a transportista</h4>
      <div style={{ padding: 20 }}>
        <FormControlLabel
          control={<Checkbox checked={sucursal.sucursal_pt_usar || false} onChange={(e) => _onChange('sucursal_pt_usar', e.target.checked)} />}
          label="Utilizar para calcular pagos"
        />
        <TextField variant='outlined' style={{ width: '100%' }} label='Entregas locales' value={sucursal.sucursal_pt_locales || ''} onChange={(e) => _onChange('sucursal_pt_locales', e.target.value)} />
        <TextField variant='outlined' style={{ width: '100%' }} label='Autoservicios' value={sucursal.sucursal_pt_autoservicios || ''} onChange={(e) => _onChange('sucursal_pt_autoservicios', e.target.value)} />
        <TextField variant='outlined' style={{ width: '100%' }} label='Entregas foraneas' value={sucursal.sucursal_pt_foraneas || ''} onChange={(e) => _onChange('sucursal_pt_foraneas', e.target.value)} />
        <TextField variant='outlined' style={{ width: '100%' }} label='Con entrega' value={sucursal.sucursal_pt_con_entrega || ''} onChange={(e) => _onChange('sucursal_pt_con_entrega', e.target.value)} />
        <TextField variant='outlined' style={{ width: '100%' }} label='Sin entrega' value={sucursal.sucursal_pt_sin_entrega || ''} onChange={(e) => _onChange('sucursal_pt_sin_entrega', e.target.value)} />
      </div>

      <div style={{ textAlign: 'right' }}>
        <Button onClick={savePorcentajes}>Guardar porcentajes</Button>
      </div>

      <Snackbar
        open={SB.open}
        onClose={() => { setSB({ open: false }) }}
        TransitionComponent={Slide}
        message={<span>{SB.msg}</span>}
      />
    </div>
  )
}
